<template>
  <div class="home">
    <div class="header">
      <div class="logo"></div>
    </div>
    <div class="content">
      <div class="contentLogo">
        <!-- <div class="nameLogo"></div> -->
        <div class="name">
          AI Sweetheart
        </div>
      </div>
      <div class="contentTag"></div>
      <!-- <div class="contentBtn">
        <div class="contentBtnApp"><i></i>App store</div>
        <div class="contentBtnGoogle"><i></i>Google Play</div>
      </div> -->
    </div>
    <footer-view></footer-view>
  </div>
</template>

<script>
// @ is an alias to /src
import FooterView from "@/components/footer.vue";

export default {
  name: "Home",
  components: {
    FooterView,
  },
};
</script>
<style lang="less" scoped>
.home {
  width: 100%;
  height: 100%;
  background: url("../assets/images/bg.png") no-repeat center top #151518;
  background-size: cover;
  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 0.64rem;
    // padding: 0 3rem;
    .logo{
      width: 1.97rem;
      height: 0.34rem;
      margin-top: .19rem;
      margin-left: 25%;
      background-image: url("../assets/images/logo.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
  .content {
    height: 100%;
    width: 100%;
    padding-bottom: 0.9rem;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-end;
    .contentLogo {
      display: flex;
      align-items: center;
      .nameLogo {
        width: 0.91rem;
        height: 0.9rem;
        background-image: url("../assets/images/ai.png");
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .name {
        font-size: 0.5rem;
        color: #fff;
        font-weight: bold;
      }
    }
    .contentTag {
      width: 2.21rem;
      height: 0.33rem;
      margin: 0.12rem 0 0.4rem;
      background-image: url("../assets/images/tag.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
    .contentBtn {
      display: flex;
      align-items: center;
      font-size: 0.24rem;
      font-weight: bold;
      div {
        width: 2.2rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      i {
        width: 0.24rem;
        height: 0.24rem;
        margin-right: 0.08rem;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }
      .contentBtnApp {
        background: #111111;
        border: 0.01rem solid #ffffff;
        color: #ffffff;
        i {
          background-image: url("../assets/images/apple.png");
        }
      }
      .contentBtnGoogle {
        background: #ffffff;
        color: #111111;
        margin-left: 0.2rem;
        i {
          background-image: url("../assets/images/google.png");
        }
      }
    }
  }
}
</style>
